import createIcon from '../../createIcon';

/**
 * @component @name ReportOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuMzY1MiA2LjY0MDM1SDEzLjM2NTJWOS41NjAzNUwyMC4yNzUyIDE2LjQ3MDRMMjEuMzY1MiAxNS4zNzA0VjcuOTEwMzVMMTYuMDk1MiAyLjY0MDM1SDguNjM1MjNMNy41NDUyMyAzLjc0MDM1TDExLjM2NTIgNy41NjAzNVY2LjY0MDM1Wk0yMi42MzUyIDIxLjM3MDRMMi42MzUyMyAxLjM2MDM1TDEuMzY1MjMgMi42MzAzNUw1LjAwNTIzIDYuMjcwMzVMMy4zNjUyMyA3LjkxMDM1VjE1LjM3MDRMOC42MzUyMyAyMC42NDA0SDE2LjA5NTJMMTcuNzM1MiAxOS4wMTA0TDIxLjM2NTIgMjIuNjQwNEwyMi42MzUyIDIxLjM3MDRaTTEyLjM2NTIgMTYuOTQwNEMxMS42NDUyIDE2Ljk0MDQgMTEuMDY1MiAxNi4zNjA0IDExLjA2NTIgMTUuNjQwNEMxMS4wNjUyIDE0LjkyMDQgMTEuNjQ1MiAxNC4zNDA0IDEyLjM2NTIgMTQuMzQwNEMxMy4wODUyIDE0LjM0MDQgMTMuNjY1MiAxNC45MjA0IDEzLjY2NTIgMTUuNjQwNEMxMy42NjUyIDE2LjM2MDQgMTMuMDg1MiAxNi45NDA0IDEyLjM2NTIgMTYuOTQwNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReportOff = createIcon('ReportOff', [
  [
    'path',
    {
      d: 'M11.3652 6.64035H13.3652V9.56035L20.2752 16.4704L21.3652 15.3704V7.91035L16.0952 2.64035H8.63523L7.54523 3.74035L11.3652 7.56035V6.64035ZM22.6352 21.3704L2.63523 1.36035L1.36523 2.63035L5.00523 6.27035L3.36523 7.91035V15.3704L8.63523 20.6404H16.0952L17.7352 19.0104L21.3652 22.6404L22.6352 21.3704ZM12.3652 16.9404C11.6452 16.9404 11.0652 16.3604 11.0652 15.6404C11.0652 14.9204 11.6452 14.3404 12.3652 14.3404C13.0852 14.3404 13.6652 14.9204 13.6652 15.6404C13.6652 16.3604 13.0852 16.9404 12.3652 16.9404Z',
      key: 'cmboii',
    },
  ],
]);

export default ReportOff;
